<template>
  <PgButtonActionsContext class="pg-page-echart" :actions="actions">
    <PgButtonGroup
      class="pg-page-echart__button"
      :list="detailButtons"
      :type="'text'"
      :round="false"
      :compileData="{}"
    >
    </PgButtonGroup>
    <PgTopRemind
      class="pg-page-echart__remind"
      :errors="topErrors"
      :success="topSuccess"
    ></PgTopRemind>

    <slot></slot>
  </PgButtonActionsContext>
</template>
<script setup>
import { PgButtonActionsContext } from '../../button-actions-context/index'
import { PgTopRemind } from '../../top-remind/index'
import { useButtonPage, useTopErrors } from '../../../hooks/index'
import { PgButtonGroup } from '../../button-group/index'

const props = defineProps({
  menus: Array,
  detailMenuLead: {
    type: String,
    default: 'DETAIL',
  },
  buttonActions: Object,
})

const reload = () => {
  console.log('reload')
}

const { getButtonByKey } = useButtonPage(props.menus)
const detailButtons = getButtonByKey(props.detailMenuLead)

const { topErrors, updateErrors, topSuccess, updateSuccess } = useTopErrors()

const actions = {
  ...props.buttonActions,
  updateTopErrors: ({ errors }) => updateErrors(errors),
  updateTopSuccess: ({ data }) => updateSuccess(data),
  reload,
}
</script>
<style lang="scss">
@import '../style/page-echart.scss';
</style>
